import React, {Component} from 'react';
import * as Sentry from '@sentry/browser';
import LogRocket from 'logrocket';
import RouteRoot from "./RouteRoot";
import auth from "./data/auth";
import './App.css';
import ToastRx from "./components/extras/ToastRx";
import ErrorBoundary from "./components/extras/ErrorBoundary";
import AlertRx from "./components/extras/AlertRx";
import localDB from "./data/localDB";
import LocalData from "./data/LocalData";
import QuestionDialogRx from "./components/extras/QuestionDialogRx";
import globals from "./data/globals";

class App extends Component {
    constructor() {
        super();
        this.state = {
            loading: true
        };

        if(!globals.DEBUG && !globals.LOCAL_DEBUG){
            LogRocket.init(globals.LOG_ROCKET_KEY, {
                dom: {
                  textSanitizer: false,
                  inputSanitizer: false,
                },
            });
            Sentry.init({
                dsn: globals.SENTRY_DSN,
                tracesSampleRate: 1.0,
                beforeSend(event) {
                    if(typeof(event.user) === 'object'){
                        event.user = localDB.getUser();
                        event.user.session = localDB.getAuthToken();
                        event.user.version = '1.0.91'
                    }
                    const logRocketSession = LogRocket.sessionURL;
                    if (logRocketSession !== null) {
                        event.extra["LogRocket"] = logRocketSession;
                    }
                    return event;
                },
                ignoreErrors:[
                    'ResizeObserver loop limit exceeded',
                    'Access is denied.',
                    "Can't execute code from a freed script"
                ]
            });
            if(localDB.getUser()){
                Sentry.setUser({ id: localDB.getUser().email });
                LogRocket.identify(localDB.getUser()['id'], {
                    name: localDB.getUser().full_name,
                    email: localDB.getUser().email
                  });
            }

            Sentry.configureScope(scope => {
                scope.setExtra("sessionURL", LogRocket.sessionURL);
            });

            LogRocket.getSessionURL(sessionURL => {
                Sentry.configureScope(scope => {
                    scope.setExtra("sessionURL", sessionURL);
                });
            });
        }
    };

    render() {
        return (
            this.state.loading ? null:
                <ErrorBoundary>
                    <div>
                        <RouteRoot/>
                        <ToastRx />
                        <AlertRx />
                        <QuestionDialogRx />
                    </div>
                </ErrorBoundary>
        );
    };

    async componentDidMount(){
        await this.initialFetch();
    };

    async initialFetch() {
        try{
            auth.refresh().then(res =>{
                localDB.initialData(res);
                LocalData.products();
                LocalData.clients();
                LocalData.providers();
            }).catch(()=>{
                localDB.cleanSession();
            }).finally(() =>{
                setTimeout(()=>{
                    const ele = document.getElementById('ipl-progress-indicator');
                    ele.parentNode.removeChild(ele);
                    this.setState({loading:false});
                }, 2000);
            });
        }catch (e) {
            this.setState({loading:false});
            localDB.cleanSession();
        }
    };
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js